// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"215":"af856bd8","245":"f6b63cdd","276":"6f71b4ec","336":"04226624","368":"15903771","463":"ee936018","488":"ec2ec7bb","646":"c3fef077","706":"1f821621","976":"99d9572c","981":"49dbc076"}[chunkId] + ".css";
};